/* assets/custom-header-height.js */
(() => {
  if (window.__customHeaderFix) return;
  window.__customHeaderFix = true;

  const onReady = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  };

  // 計測対象：テーマに合わせてセレクタを増やしてOK
  const HEADER_SELECTORS = [
    '[data-header]',           // Pipeline系でよくある
    '.site-header',
    'header.header',
    '[data-section-type="header"]'
  ];

  const getHeaderEl = () => {
    for (const s of HEADER_SELECTORS) {
      const el = document.querySelector(s);
      if (el) return el;
    }
    return null;
  };

  const setVar = (px) => {
    document.documentElement.style.setProperty('--header-height', `${Math.round(px)}px`);
  };

  const measure = () => {
    const header = getHeaderEl();
    if (!header) return;

    // ヘッダー自体＋アナウンスバーがheader外の場合もあるので上辺からの高低差でざっくり測るならここを拡張してもOK
    const rect = header.getBoundingClientRect();
    const height = rect.height;

    if (height && isFinite(height)) setVar(height);
  };

  const debounce = (fn, ms = 100) => {
    let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  };

  onReady(() => {
    // 1) 初回
    measure();

    // 2) windowイベント
    window.addEventListener('resize', debounce(measure, 120));
    window.addEventListener('orientationchange', debounce(measure, 120));

    // 3) 画像・フォント読み込み後（行高が変わる対策）
    window.addEventListener('load', () => setTimeout(measure, 0));
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => setTimeout(measure, 0)).catch(() => {});
    }

    // 4) アナウンスバー・言語切替などでDOMが増減する場合に備えて監視
    const mo = new MutationObserver(debounce(measure, 60));
    mo.observe(document.body, { childList: true, subtree: true, attributes: true });

    // 5) テーマが独自イベントを出すなら拾う（例）
    document.addEventListener('theme:header:resize', debounce(measure, 60));
  });
})();
